import { render, staticRenderFns } from "./Nuevo-movimiento-de-stock.vue?vue&type=template&id=2c4c89b6&scoped=true"
import script from "./Nuevo-movimiento-de-stock.vue?vue&type=script&lang=js"
export * from "./Nuevo-movimiento-de-stock.vue?vue&type=script&lang=js"
import style0 from "./Nuevo-movimiento-de-stock.vue?vue&type=style&index=0&id=2c4c89b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c89b6",
  null
  
)

export default component.exports